var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F9B71D",
    d: "m8.34 10.18-1.172 2.153-1.171-2.152a4.739 4.739 0 0 0-1.843-1.843L2.001 7.167l2.153-1.171a4.739 4.739 0 0 0 1.843-1.843L7.168 2 8.34 4.153a4.739 4.739 0 0 0 1.843 1.843l2.153 1.17-2.153 1.172a4.739 4.739 0 0 0-1.843 1.843Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillOpacity: 0.6,
    d: "m8.34 10.18-1.172 2.153-1.171-2.152a4.739 4.739 0 0 0-1.843-1.843L2.001 7.167l2.153-1.171a4.739 4.739 0 0 0 1.843-1.843L7.168 2 8.34 4.153a4.739 4.739 0 0 0 1.843 1.843l2.153 1.17-2.153 1.172a4.739 4.739 0 0 0-1.843 1.843Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9B71D",
    d: "m15.78 22.666 1.566-2.858a6.273 6.273 0 0 1 2.463-2.463l2.859-1.567-2.859-1.568a6.274 6.274 0 0 1-2.463-2.462l-1.567-2.86-1.567 2.86a6.273 6.273 0 0 1-2.463 2.463L8.89 15.777l2.86 1.567a6.272 6.272 0 0 1 2.462 2.463l1.567 2.858Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    fillOpacity: 0.6,
    d: "m15.78 22.666 1.566-2.858a6.273 6.273 0 0 1 2.463-2.463l2.859-1.567-2.859-1.568a6.274 6.274 0 0 1-2.463-2.462l-1.567-2.86-1.567 2.86a6.273 6.273 0 0 1-2.463 2.463L8.89 15.777l2.86 1.567a6.272 6.272 0 0 1 2.462 2.463l1.567 2.858Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 12.335,
    x2: 12.335,
    y1: 22.666,
    y2: 2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 12.335,
    x2: 12.335,
    y1: 22.666,
    y2: 2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "61996e02b506e9618e269e16a25287bb.svg";
export { ForwardRef as ReactComponent };